export default "__VITE_ASSET__q4h9i5Za__"